import axios from 'axios';
import { trimStringForQuery } from 'utils/utils';
import userRoles from 'utils/enums/user-roles.enum';

const API_URL = '/api/v1/users/';
const INVITE = 'invite';
const REGISTER = 'register';
const VERIFY_INVITATION_TOKEN = 'verify-invitation';
const START_PASSWORD_RESET = 'start-password-reset';
const COMPLETE_PASSWORD_RESET = 'complete-password-reset';
const SEARCH = 'search';

const invite = (data) => {
	return axios.post(`${API_URL}${INVITE}`, data);
}

const verifyInvitationToken = (token) => {
	return axios.get(`${API_URL}${VERIFY_INVITATION_TOKEN}/${token}`);
}

const register = (data) => {
	return axios.post(`${API_URL}${REGISTER}`, {
		...data,
	});
}

const startPasswordReset = (email, username) => {
	console.log('{user.service} - startPasswordReset invoked: email = ' + email + ', username = ' + username);
	const user = {
		email,
		username,
	};

	return axios.post(`${API_URL}${START_PASSWORD_RESET}`, user);
}

const confirmPasswordReset = (otp, password) => {
	console.log('{user.service} - confirmPasswordReset invoked: otp = ' + otp + ', password = ' + password);
	const confirmation = {
		otp,
		password,
	};

	return axios.post(`${API_URL}${COMPLETE_PASSWORD_RESET}`, confirmation);
}

const searchUsers = ({
	filterQuery,
	pageIndex,
	pageSize,
	sortBy,
	filterFields = [],
}) => {
	return axios.post(`${API_URL}${SEARCH}`, {
		page: pageIndex,
		count: pageSize,
		sortBy,
		filters: [
			{
				type: 'string',
				name: 'fullName',
				value: trimStringForQuery(filterQuery),
			},
			{
				type: 'string',
				name: 'email',
				value: trimStringForQuery(filterQuery),
			},
			...filterFields,
		],
	});
};

const searchCustomerRepresentative = (params) => searchUsers({
	...params,
	filterFields: [
		{
			type: 'string',
			name: 'role',
			value: userRoles.CustomerRepresentative,
			exactMatch: true,
			negative: false,
		},
	],
});

const deleteUserById = (id) => axios.delete(`${API_URL}${id}`);

export {
	invite,
	verifyInvitationToken,
	register,
	startPasswordReset,
	confirmPasswordReset,
	searchUsers,
	searchCustomerRepresentative,
	deleteUserById,
};
